import Vue from 'vue'
import VueResource from 'vue-resource'
import VueI18n from 'vue-i18n'
import VueMeta from 'vue-meta';
// import en from './locales/en.json'
import VueScrollTo from 'vue-scrollto';
import {
  AlertPlugin,
  CarouselPlugin,
  DropdownPlugin,
  EmbedPlugin,
  ModalPlugin,
  NavPlugin,
  PaginationPlugin,
  SidebarPlugin
} from 'bootstrap-vue';

import store from './store';
import router from './router';
import i18n from './i18n';
import MarathonPaths from './plugins/marathon-paths';
import App from './App.vue';

// --- Global styles ---
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'flag-icons/css/flag-icons.min.css';
import 'animate.css';
import './style.css';
// --- Plugin registration ---
Vue.use(VueResource);
Vue.use(VueMeta);
Vue.use(VueScrollTo);
Vue.use(AlertPlugin);
Vue.use(CarouselPlugin);
Vue.use(DropdownPlugin);
Vue.use(EmbedPlugin);
Vue.use(ModalPlugin);
Vue.use(NavPlugin);
Vue.use(PaginationPlugin);
Vue.use(SidebarPlugin);
Vue.use(MarathonPaths);
Vue.use(VueI18n)

Vue.config.productionTip = false;

// Add checkout API paths to the existing marathonPaths (don't overwrite)
const checkoutPaths = {
  checkprices: process.env.VUE_APP_API_BASE_URL + '/payfront/v6/commercial-validate-order',
  pay: process.env.VUE_APP_API_BASE_URL + '/payfront/v6/commercial-pay',
  order: 'https://api.marathon-photos.com/website_api/v7/get_order_details'
}
Object.assign(Vue.prototype.$marathonPaths, checkoutPaths);

// Suppress NavigationDuplicated errors (common when already on the target route)
const originalPush = router.push.bind(router);
router.push = function push(location) {
  return originalPush(location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err;
    }
  });
};

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
